"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _unescape2 = _interopRequireDefault(require("lodash/unescape"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelExperienceCard = _interopRequireDefault(require("../HotelExperienceCard"));
var _MobileGallery = _interopRequireDefault(require("../MobileGallery"));
var _MobileGalleryVideo = _interopRequireDefault(require("../MobileGalleryVideo"));
var _excluded = ["description", "fullDescription", "gallery", "isMobile", "onCollapse", "title"];
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 1l35.355 35.355m0-35.355L1 36.355",
    stroke: "#FFF",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
CloseIcon.defaultProps = {
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg"
};
var cardPropTypes = _HotelExperienceCard["default"].propTypes;
var Closer = _MobileGalleryVideo["default"].Closer;
var createMarkup = function createMarkup(encodedHtml) {
  return {
    __html: (0, _unescape2["default"])(encodedHtml)
  };
};
var HotelExperienceExpanded = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var description = _ref.description,
    fullDescription = _ref.fullDescription,
    gallery = _ref.gallery,
    isMobile = _ref.isMobile,
    onCollapse = _ref.onCollapse,
    title = _ref.title,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledExperienceExpanded, (0, _extends2["default"])({
    isMobile: isMobile
  }, props), !(0, _isEmpty2["default"])(gallery) && /*#__PURE__*/_react["default"].createElement(StyledGalleryContainer, null, /*#__PURE__*/_react["default"].createElement(_MobileGallery["default"], {
    controls: !isMobile,
    counter: !isMobile,
    height: isMobile ? 210 : 400,
    images: gallery,
    key: title + description
  }), !isMobile && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledOverlay, null, /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    dangerouslySetInnerHTML: createMarkup(description)
  })), /*#__PURE__*/_react["default"].createElement(StyledCollapseIcon, {
    width: 38,
    height: 38,
    onClick: onCollapse
  }))), /*#__PURE__*/_react["default"].createElement(StyledText, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), /*#__PURE__*/_react["default"].createElement(StyledFullDescription, {
    isMobile: isMobile,
    dangerouslySetInnerHTML: createMarkup(fullDescription)
  })));
});
HotelExperienceExpanded.propTypes = {
  className: _propTypes["default"].string,
  description: _propTypes["default"].string,
  fullDescription: _propTypes["default"].string,
  gallery: cardPropTypes.gallery,
  isMobile: _propTypes["default"].bool,
  onCollapse: _propTypes["default"].func,
  title: _propTypes["default"].string.isRequired
};
HotelExperienceExpanded.defaultProps = {
  className: '',
  description: null,
  fullDescription: null,
  gallery: null,
  isMobile: false,
  onCollapse: Function.prototype
};
var StyledGalleryContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceExpanded__StyledGalleryContainer",
  componentId: "sc-fyc0mk-0"
})(["width:100%;overflow:hidden;position:relative;"]);
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceExpanded__StyledText",
  componentId: "sc-fyc0mk-1"
})(["display:block;"]);
var StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceExpanded__StyledOverlay",
  componentId: "sc-fyc0mk-2"
})(["background:linear-gradient(to bottom,#0000,#0005);bottom:0;width:100%;color:#fff;position:absolute;z-index:3;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceExpanded__StyledDescription",
  componentId: "sc-fyc0mk-3"
})(["max-width:400px;padding:24px;text-shadow:1px 2px #0002;"]);
var StyledCollapseIcon = (0, _styledComponents["default"])(CloseIcon).withConfig({
  displayName: "HotelExperienceExpanded__StyledCollapseIcon",
  componentId: "sc-fyc0mk-4"
})(["position:absolute;top:20px;right:16px;cursor:pointer;z-index:3;filter:drop-shadow(0px 1px 4px rgba(0,0,0,.5));svg,path{fill:", ";stroke:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
});
var StyledTitle = _styledComponents["default"].span.withConfig({
  displayName: "HotelExperienceExpanded__StyledTitle",
  componentId: "sc-fyc0mk-5"
})(["margin-right:7px;"]);
var StyledExperienceExpanded = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceExpanded__StyledExperienceExpanded",
  componentId: "sc-fyc0mk-6"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme,
    isMobile = _ref4.isMobile;
  return "\n    height: 100%;\n    padding-top: ".concat(isMobile ? 0 : 10, "px;\n\n    ").concat(StyledText, " {\n      padding: ").concat(isMobile ? '10px 11px 20px' : '20px 23px 50px', ";\n    }\n\n    ").concat(StyledTitle, " {\n      color: ").concat(theme.colors.blackBase, ";\n      ").concat(theme.typography[isMobile ? 'headline3' : 'headline1'], "\n    }\n\n    ").concat(!isMobile && "\n      ".concat(StyledGalleryContainer, " {\n        border-radius: ").concat(theme.shape.borderRadiusBig, ";\n      }\n      ").concat(Closer, " {\n        right: 70px;\n        top: 21px;\n      }\n    "), "\n  ");
});
var StyledFullDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceExpanded__StyledFullDescription",
  componentId: "sc-fyc0mk-7"
})(["text-align:left;white-space:normal;", ""], function (_ref5) {
  var theme = _ref5.theme,
    isMobile = _ref5.isMobile;
  return "\n    color: ".concat(theme.colors.blackLight, ";\n    font-size:  ").concat(isMobile ? 13 : 16, "px;\n    margin-top: ").concat(isMobile ? 8 : 16, "px;\n\n    h1, h2, h3 {\n      ").concat(theme.typography[isMobile ? 'mobileHeadline1' : 'headline3'], "\n      color: ").concat(theme.colors.black, ";\n      margin-bottom: ").concat(isMobile ? 11 : 7, "px;\n    }\n\n    p ~ h1,\n    p ~ h2,\n    p ~ h3 {\n      margin-top: ").concat(isMobile ? 18 : 35, "px;\n    }\n\n    p ~ p {\n      margin-top: ").concat(isMobile ? 11 : 12, "px;\n    }\n  ");
});
var _default = exports["default"] = HotelExperienceExpanded;